export default "__VITE_ASSET__YPYdSkLw__"